export const validNumber = new RegExp(/^\d+$/)